"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zugentlastung = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const Article_1 = require("../Article");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_product_models_1 = require("@igus/echain-product-models");
class Zugentlastung extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'Zugentlastung';
    }
    get mounting() {
        return this.model.Mounting;
    }
    set mounting(value) {
        this.model.Mounting = value;
    }
    get leitungsdurchmesser() {
        return this.model.Leitungsdurchmesser;
    }
    set leitungsdurchmesser(value) {
        this.model.Leitungsdurchmesser = value;
    }
    get laengeneingabe() {
        return this.model.Laengeneingabe;
    }
    set laengeneingabe(value) {
        this.model.Laengeneingabe = value;
    }
    get leitungen() {
        return this.model.Leitungen;
    }
    set leitungen(value) {
        this.model.Leitungen = value;
    }
    get breite() {
        return echain_shared_quantities_1.Q.optional(this.model.Breite);
    }
    set breite(value) {
        this.model.Breite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get hoehe() {
        return echain_shared_quantities_1.Q.optional(this.model.Hoehe);
    }
    set hoehe(value) {
        this.model.Hoehe = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get laenge() {
        return echain_shared_quantities_1.Q.optional(this.model.Laenge);
    }
    set laenge(value) {
        this.model.Laenge = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get dmin() {
        return echain_shared_quantities_1.Q.optional(this.model.Dmin);
    }
    set dmin(value) {
        this.model.Dmin = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get dmax() {
        return echain_shared_quantities_1.Q.optional(this.model.Dmax);
    }
    set dmax(value) {
        this.model.Dmax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get zaehne() {
        return this.model.Zaehne;
    }
    set zaehne(value) {
        this.model.Zaehne = value;
    }
    get weight() {
        return echain_shared_quantities_1.Q.optional(this.model.Weight);
    }
    set weight(value) {
        this.model.Weight = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get montage() {
        return this.model.Montage;
    }
    set montage(value) {
        this.model.Montage = value;
    }
    get montagetyp() {
        return this.model.Montagetyp;
    }
    set montagetyp(value) {
        this.model.Montagetyp = value;
    }
    get isSet() {
        return this.model.IsSet;
    }
    set isSet(value) {
        this.model.IsSet = value;
    }
    get sort() {
        return this.model.Sort;
    }
    set sort(value) {
        this.model.Sort = value;
    }
    get typ() {
        return this.model.Typ;
    }
    set typ(value) {
        this.model.Typ = value;
    }
    get drawingProperties() {
        return this.model.DrawingProperties;
    }
    get localTransform() {
        return this.model.LocalTransform;
    }
    set localTransform(value) {
        this.model.LocalTransform = value;
    }
    static fromScratch() {
        return new Zugentlastung({
            ArticleType: echain_product_models_1.ArticleType.zugentlastung,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            Montagetyp: [],
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Zugentlastung.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const ze = Zugentlastung.fromJson(args, cloneStrategy);
        ze.artNrExists = true;
        return ze;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Zugentlastung.fromInventedArtNrArgs: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const ze = Zugentlastung.fromJson(args, cloneStrategy);
        ze.artNrExists = false;
        return ze;
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const zugentlastung = Zugentlastung.fromScratch();
        zugentlastung.fromJson(json, cloneStrategy);
        return zugentlastung;
    }
    static fromModel(model) {
        const zugentlastung = Zugentlastung.fromScratch();
        Object.assign(zugentlastung.model, model);
        Object.assign(model, zugentlastung.model);
        zugentlastung.model = model;
        return zugentlastung;
    }
    clone() {
        return this._clone(Zugentlastung.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    isRequireCProfil() {
        const result = this.montagetyp.find((mt) => {
            return ((mt === echain_shared_articles_1.ZugentlastungMontagetyp.CProfilVorAE ||
                mt === echain_shared_articles_1.ZugentlastungMontagetyp.HDCProfil ||
                mt === echain_shared_articles_1.ZugentlastungMontagetyp.KMACProfil ||
                mt === echain_shared_articles_1.ZugentlastungMontagetyp.KMACProfilCFV42 ||
                mt === echain_shared_articles_1.ZugentlastungMontagetyp.KMACProfilCFV80 ||
                mt === echain_shared_articles_1.ZugentlastungMontagetyp.KMACProfilKurz ||
                mt === echain_shared_articles_1.ZugentlastungMontagetyp.KMAE3) &&
                this.typ !== echain_shared_articles_1.ZugentlastungTyp.KMA_C_Profil &&
                this.typ !== echain_shared_articles_1.ZugentlastungTyp.HD_C_Profil);
        });
        return Boolean(result);
    }
    isRequireHutschiene() {
        const result = this.montagetyp.find((mt) => {
            return mt === echain_shared_articles_1.ZugentlastungMontagetyp.KMAHutschiene && this.typ !== echain_shared_articles_1.ZugentlastungTyp.Hutschiene;
        });
        return Boolean(result);
    }
    /**
     * Breite of zugentlastung is always in mm
     */
    updateBreite(breite_mm) {
        this.breite = echain_shared_quantities_1.Length.mm(breite_mm);
        this.artNrGenerated = this.generateArtNr(echain_shared_i18n_1.LocaleService.getArtNrCountry());
    }
    generateArtNr(artNrCountry) {
        let artNr = this.artNr;
        const separator = echain_shared_i18n_1.LocaleUtil.getArtNrSeparator(artNrCountry);
        if (artNr && this.breite) {
            const padNum = this.breite.mm.toString().padStart(3, '0');
            artNr = artNr
                .replace(`${separator}XXX${separator}`, `${separator}${padNum}${separator}`)
                .replace(new RegExp(`\\${separator}XXX$`), `${separator}${padNum}`);
        }
        return artNr;
    }
    isCProfil() {
        return this.typ === echain_shared_articles_1.ZugentlastungTyp.KMA_C_Profil || this.typ === echain_shared_articles_1.ZugentlastungTyp.HD_C_Profil;
    }
    isHutschiene() {
        return this.typ === echain_shared_articles_1.ZugentlastungTyp.Hutschiene;
    }
}
exports.Zugentlastung = Zugentlastung;
//# sourceMappingURL=Zugentlastung.js.map